import React from 'react'
import './Intro.css'
import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';
import Reroar from '../../img/Reroar.jpg';
import {Link} from 'react-scroll';

const Intro = () => {
  return (
    <div className='intro'>
        <div className='i-left'>
        <div className='i-name'>
            <span> Hey! I am</span> 
            <span> Rounit Singh</span>
            <span>MERN stack web developer, passionate and dedicated to my work</span>

            
        </div>
        <Link spy={true} to='Contact' smooth={true}>
        <button className='button i-button' >Hire Me</button>
        </Link>
        <div className='i-icons'>
            <a href='https://github.com/Reroar' target='_blank' rel='noreferrer'><img src={Github} alt="" /></a>
           <a href='https://www.linkedin.com/in/rounit-kumar-singh-2a149a201/' target='_blank' rel='noreferrer'> <img src={LinkedIn} alt="" /></a>
            <a href='https://www.instagram.com/rounitksingh/' target='_blank' rel='noreferrer'><img src={Instagram} alt="" /></a>
        </div>
        </div>
        <div className='i-right'>
        <img className='reroar' src={Reroar} alt = '' />
        <div className='blur' style={{ background: "rgb(238 210 255)"}}></div>
        <div className='blur' style={{background: '#C1F5FF', top: '60%', left: '40%',height: '11rem'}}></div>
        </div>
    </div>
  )
}

export default Intro